module.exports = __webpack_public_path__ + "img/SMT_15_Mr_Andy_Seet.53c3b2eb.jpg";